import React, { useState, useEffect } from 'react';

/**
 * show a tooltip when the label name is too long
 */
const LabelWithTooltip = ({label, description="", dateUploaded="", parentProps, cssClass="", followCursor=false}) => {

    const [mouseX, setMouseX] = useState(0);    // px from left
    const [mouseY, setMouseY] = useState(0);    // px from top
    const [right, setRight] = useState('auto'); // px from right
    const [tooltipText, setTooltipText] = useState("");
    const [shouldShowTooltip, setShouldShowTooltip] = useState(false);
    const [cursor, setCursor] = useState({x: 0, y: 0});
  
    let _hasLongLabel = (followCursor || parentProps.followCursor) ? label.length >= 38 || false : label.length >= 18 || false;

    let hasLongLabel = (description.length || dateUploaded.length) ? true : _hasLongLabel;
  
    const showTooltip = (event) => {
      if(hasLongLabel) {
        // adjust popup offset for filters on left rail
        let set_x = 90;
        let set_y = event.clientY - 115;
        let _right = 'auto';
        if(parentProps.viewOnly) {
          if('map' in parentProps) {
            // adjust popup offset for insights on right rail
            set_x = 'auto';
            set_y = event.clientY - 120;
            _right = 100;
          } else {
            // adjust popup offset for middle rail
            set_x = event.clientX - 390;
            set_y = event.clientY - 260;
          }      
        }
        if(followCursor || parentProps.followCursor) {
          // have the popup follow the users cursor
          set_x = cursor.x - 90;
          set_y = cursor.y - 60;
        }
        setMouseX(set_x);
        setMouseY(set_y);
        setRight(_right);
        setTooltipText(label);
        setShouldShowTooltip(true);
      }
    }
    const hideTooltip = () => {
      setTimeout(() => {
        setMouseX(0);
        setMouseY(0);
        setRight('auto');
        setTooltipText("");
        setShouldShowTooltip(false);
      }, 20);
    }

    useEffect(() => {
      if(followCursor || parentProps.followCursor) {
        const handleMouseMove = (event) => {
          const x = event.clientX;
          const y = event.clientY;
          setCursor({x: x, y: y});
        };
        
        document.addEventListener('mousemove', handleMouseMove);
        
        // Cleanup function to remove the event listener
        return () => {
          document.removeEventListener('mousemove', handleMouseMove);
        };
      }
    // eslint-disable-next-line react-hooks/exhaustive-deps 
    }, [followCursor]);
  
    return (
      <div onMouseEnter={showTooltip} onMouseLeave={hideTooltip}>
        <label className={hasLongLabel ? `${cssClass} long-text-label` : `${cssClass}`}>
          {label}
        </label>
        {shouldShowTooltip && (
          <div 
            className="label-tooltip"
            style={{ 
              top: mouseY, 
              left: mouseX,
              right: right
            }}
          >
            <div className="fw-medium">{tooltipText}</div>
            <div>
              <i>
                {description && <>{description}<br /></>}
                {dateUploaded}
              </i>
            </div>
          </div>
        )}
      </div>)
  }


export default LabelWithTooltip;
  